export default function rangeArrayUtil (start, end, step = 1) {
  if (typeof end === 'undefined') {
    end = start
    start = 0
  }

  const result = []
  if (step > 0) {
    for (let i = start; i < end; i += step) {
      result.push(i)
    }
  } else if (step < 0) {
    for (let i = start; i > end; i += step) {
      result.push(i)
    }
  }
  return result
}
